<template>
    <div class="view-bar-item">
        <router-link tag="div" class="view-bar-link" :to="route" active-class="active" exact>
            <slot/>
        </router-link>
        <div class="view-bar-header-actions">
            <small-icon-button :icon="action.icon" @press="emitAction(action.name)" v-for="action in actions"/>
        </div>
    </div>
</template>

<script>
    import SmallIconButton from "../button/SmallIconButton";
    export default {
        name: "ViewBarItem",
        components: {SmallIconButton},
        props: {
            route: String,
            actions: Array
        },
        data: function () {
            return {}
        },
        methods: {
            emitAction(actionName) {
                this.$emit(actionName);
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../styles/global";

.view-bar-link {
    padding: 10px;
    color: var(--input-font-color);
    white-space: nowrap;
    cursor: pointer;
}

.view-bar-item {
    display: grid;
    grid-template: 1fr / 1fr min-content;
    width: 90%;
    align-items: center;
    justify-content: center;
}

.view-bar-link:hover {
    background: linear-gradient(to right, rgba(255,255,255, 0.04), rgba(255,255,255, 0.0))
}

.active {
    /*background-color: rgba(255, 255, 255, 0.15);*/
    //text-decoration: underline;
    ////text-decoration-color: $openRed;
    color: var(--input-active-font-color);
}
.view-bar-header-actions {
    * {
        margin-left: 5px;
    }
    margin-right: 10px;
    display: flex;
    flex-flow: row;

}
</style>